import { put, call } from 'redux-saga/effects';
import { UsersGroupsPermissionAction, UIAction } from '../actions';
import { UsersGroupPermissionsService } from '../services';
import { generateReadableError } from 'hooks';


export function* updateGroupPermission(action) {
  yield put(UsersGroupsPermissionAction.updateGroupPermissionSuccess(null));
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const { data } = yield call(UsersGroupPermissionsService.getInstance().updateGroupPermissions, action.payload);
    yield put(UsersGroupsPermissionAction.updateGroupPermissionSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}



export function* getGroupsPermissions(action) {
  //yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const { data } = yield call(UsersGroupPermissionsService.getInstance().fetchGroupPermissions, action.payload);
    yield put(UsersGroupsPermissionAction.getGroupPermissionSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

//

export function* updateUserPermission(action) {
  yield put(UsersGroupsPermissionAction.updateUserPermissionSuccess(null));
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const { data } = yield call(UsersGroupPermissionsService.getInstance().updateUserPermissions, action.payload);
    yield put(UsersGroupsPermissionAction.updateUserPermissionSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}



export function* getUserPermissions(action) {
  //yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const { data } = yield call(UsersGroupPermissionsService.getInstance().fetchUserPermissions, action.payload);
    yield put(UsersGroupsPermissionAction.getUserPermissionSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}






